import React from 'react';
import { Space } from 'antd';
import { useHistory } from 'react-router';
import EditButton from 'components/RestActions/EditButton';
import { handleRedirectToContactDetails } from 'containers/Contacts/utils';

interface Props {
  customerType?: string;
  id: string;
  userType?: string;
}

const GroupActions = ({ customerType, id, userType }: Props) => {
  const { push } = useHistory();

  const redirectEditPage = () => {
    id &&
      push({
        hash: `#contacts/${id}/edit`,
      });
  };

  return (
    <Space>
      {customerType === 'AUTO' ? (
        <EditButton
          onClickCustom={() =>
            push(handleRedirectToContactDetails(userType, id))
          }
          isView
          permissionKey="contacts"
          action="isView"
        />
      ) : (
        <EditButton
          permissionKey="contacts"
          action="isEdit"
          onClickCustom={redirectEditPage}
        />
      )}
    </Space>
  );
};

export default GroupActions;
